export interface User {
  rin: string;
  firstName: string;
  lastName: string;
  email: string;
  delegateOf: DelegateOf[];
}

export interface DelegateOf {
  id: number;
  name: string;
  firstName: string;
  lastName: string;
  type: TypeOfPersonType;
  isAdministrator: boolean;
  traderIdentifiers: TraderIdentifier[];
  monitoredAreas: MonitoredArea[];
  drivers: Driver[];
  vehicles: TransportMeans[];
  trailers: TransportMeans[];
  hasDirectBP: boolean;
  hasDelegatedBP: boolean;
  brokerName?: string;
  brokerTin?: string;
  hasReportingObligations?: boolean;
  hasLateObligations?: boolean;
  sendEmailNotificationAboutReporting?: boolean;
}

export enum TypeOfPersonType {
  NATURAL = "NATURAL",
  LEGAL = "LEGAL",
}

export type RepresentationMode = "DIRECT" | "DELEGATED";

export interface TraderIdentifier {
  tin: string;
  typeOfIdentifier: string;
}

export interface MonitoredArea {
  value: string;
  label: string;
  trafficControlDevices: TrafficControlDevice[];
}

export interface TrafficControlDevice {
  value: string;
  label: string;
  entry: boolean;
  exit: boolean;
}

export interface Driver {
  firstName: string;
  lastName: string;
  phone?: string | null | undefined;
  email?: string | null | undefined;
}

export interface TransportMeans {
  registrationNumber: string;
  registrationCountry?: string | null | undefined;
}

export interface BusinessEntityProfileUpdateRequest {
  drivers: Driver[];
  vehicles: TransportMeans[];
  trailers: TransportMeans[];
}
